import React, { Component } from 'react';
import { connect } from 'react-redux';

class ProjectFilterInfoText extends Component {
  render() {
    return (
          <div className="text-center">
            <p className="project-filter--info-text">{this.props.infoText}</p>
          </div>
		);
    }
}


export default ProjectFilterInfoText;